module.exports = __webpack_public_path__ + "static/media/HRECOS_PANEL_DO.80f95e40.png";